import { getImageQuality } from '../utils'

const configAggregator = (node) => {
    const elements = node.querySelectorAll(
        '[data-content-type="alfakher_tradition_card"]'
    )
    const itemConfig = []

    elements.forEach((element) => {
        itemConfig.push({
            content: element.getAttribute('data-w-content'),
            heading: element.getAttribute('data-w-heading'),
            vimeoLink: element.getAttribute('data-w-vimeolink'),
            vimeoLinkMobile: element.getAttribute('data-w-vimeolinkmobile'),
            image: element.getAttribute('data-w-image'),
            imageFastlyParam: element.getAttribute('data-w-image-fastly-param'),
            mode: element.getAttribute('data-w-mode'),
            imageQuality: getImageQuality([])
        })
    })

    return {
        subheading: node.getAttribute('data-w-subline'),
        heading: node.getAttribute('data-w-heading'),
        buttonText: node.getAttribute('data-w-buttontext'),
        link: node.getAttribute('data-w-buttonlink'),
        itemConfig: itemConfig
    }
}

export default configAggregator
